import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Coffee, Wifi, Wind } from 'lucide-react';
import { SectionHeader, PremiumCard, Placeholder, Button } from './ui';
export function Accommodation() {
  return <section id="alojamiento" className="py-24 md:py-32 bg-noronha-graphite/30" data-id="element-15">
      <div className="container mx-auto px-6" data-id="element-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-17">
          <div className="order-2 lg:order-1" data-id="element-18">
            <Placeholder type="image" aspectRatio="portrait" label="Pousada Dois Irmãos" className="w-full max-w-md mx-auto lg:mx-0" data-id="element-19" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-20">
            <SectionHeader eyebrow="Descanso Premium" title="Pousada Dois Irmãos" align="left" className="mb-8" data-id="element-21" />
            <p className="text-noronha-text-body text-lg mb-8 leading-relaxed" data-id="element-22">
              Ubicada estratégicamente cerca de las mejores playas y el centro
              de la isla. Una pousada boutique que combina el encanto rústico de
              Noronha con el confort premium que necesitas después de un día de
              buceo.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-23">
              <div className="flex items-center gap-3 text-noronha-text-heading" data-id="element-24">
                <Coffee className="w-5 h-5 text-noronha-gold" data-id="element-25" />
                <span className="text-sm" data-id="element-26">Desayuno Tropical</span>
              </div>
              <div className="flex items-center gap-3 text-noronha-text-heading" data-id="element-27">
                <Wind className="w-5 h-5 text-noronha-gold" data-id="element-28" />
                <span className="text-sm" data-id="element-29">Aire Acondicionado</span>
              </div>
              <div className="flex items-center gap-3 text-noronha-text-heading" data-id="element-30">
                <Wifi className="w-5 h-5 text-noronha-gold" data-id="element-31" />
                <span className="text-sm" data-id="element-32">Wi-Fi Starlink</span>
              </div>
              <div className="flex items-center gap-3 text-noronha-text-heading" data-id="element-33">
                <CheckCircle2 className="w-5 h-5 text-noronha-gold" data-id="element-34" />
                <span className="text-sm" data-id="element-35">Baño Privado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function Investment() {
  return <section id="inversion" className="py-24 md:py-32 bg-noronha-volcanic relative overflow-hidden" data-id="element-36">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-noronha-emerald/5 rounded-full blur-[120px] pointer-events-none" data-id="element-37" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-38">
        <SectionHeader eyebrow="Tu Lugar" title="Inversión" description="Asegura tu lugar en esta expedición exclusiva. Cupos estrictamente limitados a 12 buceadores." className="mb-16" data-id="element-39" />

        <div className="max-w-lg mx-auto" data-id="element-40">
          <PremiumCard className="relative overflow-hidden border-noronha-emerald/30" data-id="element-41">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-noronha-emerald to-noronha-petroleum" data-id="element-42" />

            <div className="text-center mb-8 pt-4" data-id="element-43">
              <p className="text-noronha-text-body line-through mb-2 text-lg" data-id="element-44">
                USD 2190
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-45">
                <span className="text-2xl font-medium text-noronha-emerald" data-id="element-46">
                  USD
                </span>
                <span className="text-6xl font-heading font-semibold text-noronha-text-heading" data-id="element-47">
                  1990
                </span>
              </div>
              <p className="font-mono text-xs text-noronha-gold mt-4 uppercase tracking-widest" data-id="element-48">
                Precio Early Bird
              </p>
            </div>

            <div className="space-y-4 mb-10" data-id="element-49">
              <div className="flex items-center gap-3 text-sm text-noronha-text-body" data-id="element-50">
                <CheckCircle2 className="w-4 h-4 text-noronha-emerald shrink-0" data-id="element-51" />
                <span data-id="element-52">Alojamiento premium (7 noches)</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-noronha-text-body" data-id="element-53">
                <CheckCircle2 className="w-4 h-4 text-noronha-emerald shrink-0" data-id="element-54" />
                <span data-id="element-55">10 inmersiones embarcadas</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-noronha-text-body" data-id="element-56">
                <CheckCircle2 className="w-4 h-4 text-noronha-emerald shrink-0" data-id="element-57" />
                <span data-id="element-58">Desayunos y almuerzos</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-noronha-text-body/50" data-id="element-59">
                <div className="w-4 h-4 rounded-full border border-noronha-text-body/30 shrink-0 flex items-center justify-center" data-id="element-60">
                  <span className="w-1 h-1 bg-noronha-text-body/30 rounded-full" data-id="element-61" />
                </div>
                <span data-id="element-62">No incluye vuelos internacionales/domésticos</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-noronha-text-body/50" data-id="element-63">
                <div className="w-4 h-4 rounded-full border border-noronha-text-body/30 shrink-0 flex items-center justify-center" data-id="element-64">
                  <span className="w-1 h-1 bg-noronha-text-body/30 rounded-full" data-id="element-65" />
                </div>
                <span data-id="element-66">No incluye tasas ambientales de la isla</span>
              </div>
            </div>

            <Button variant="primary" className="w-full py-4 text-base" data-id="element-67">
              Reservar con USD 500
            </Button>
          </PremiumCard>
        </div>
      </div>
    </section>;
}
export function NonDivers() {
  return <section className="py-24 bg-noronha-graphite/50 border-y border-noronha-petroleum/20" data-id="element-68">
      <div className="container mx-auto px-6 text-center max-w-3xl" data-id="element-69">
        <SectionHeader eyebrow="Acompañantes" title="¿Viajas con alguien que no bucea?" className="mb-8" data-id="element-70" />
        <p className="text-noronha-text-body text-lg mb-10" data-id="element-71">
          Fernando de Noronha es un paraíso tanto debajo como fuera del agua.
          Mientras nosotros buceamos, tus acompañantes pueden disfrutar de las
          playas elegidas como las más hermosas del mundo (Baía do Sancho),
          hacer snorkel con tortugas, o recorrer senderos ecológicos.
        </p>
        <p className="font-mono text-sm text-noronha-gold uppercase tracking-widest mb-8" data-id="element-72">
          Tarifa especial para no buzos disponible.
        </p>
        <Button variant="outline" data-id="element-73">Consultar tarifa acompañante</Button>
      </div>
    </section>;
}
export function PaymentTimeline() {
  const steps = [{
    title: 'Reserva',
    desc: 'USD 500 para asegurar tu lugar.',
    date: 'Hoy'
  }, {
    title: 'Cuota 1',
    desc: '30% del valor total.',
    date: '90 días antes'
  }, {
    title: 'Saldo Final',
    desc: 'Cancelación total del viaje.',
    date: '60 días antes'
  }];
  return <section className="py-24 bg-noronha-volcanic" data-id="element-74">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-75">
        <SectionHeader eyebrow="Facilidades" title="Formas de Pago" className="mb-16" data-id="element-76" />

        <div className="relative border-l border-noronha-petroleum/50 ml-4 md:ml-0 md:border-l-0 md:flex md:justify-between md:gap-8" data-id="element-77">
          {/* Desktop horizontal line */}
          <div className="hidden md:block absolute top-6 left-0 w-full h-px bg-noronha-petroleum/50" data-id="element-78" />

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="relative pl-8 md:pl-0 pb-12 md:pb-0 md:flex-1 md:text-center" data-id="element-79">
              {/* Dot */}
              <div className="absolute left-[-5px] md:left-1/2 md:-translate-x-1/2 top-0 md:top-4 w-3 h-3 bg-noronha-emerald rounded-full shadow-[0_0_10px_rgba(31,163,122,0.5)]" data-id="element-80" />

              <div className="md:pt-12" data-id="element-81">
                <span className="font-mono text-xs text-noronha-gold uppercase tracking-widest block mb-2" data-id="element-82">
                  {step.date}
                </span>
                <h4 className="text-xl font-heading text-noronha-text-heading mb-2" data-id="element-83">
                  {step.title}
                </h4>
                <p className="text-noronha-text-body text-sm" data-id="element-84">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}